"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M14 9.5V7c0-1.459-.878-2.512-1.808-2.899-.459-.191-1-.245-1.457-.004-.488.258-.735.772-.735 1.403v4a.5.5 0 0 0-.5.5v3.134A1 1 0 0 0 9 14v4a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-4a1 1 0 0 0-.5-.866V10a.5.5 0 0 0-.5-.5m-2.997-4.098c.02-.291.132-.385.2-.42.105-.056.314-.08.605.042.467.195.97.698 1.135 1.447-.798-.089-1.276-.361-1.555-.6a1.7 1.7 0 0 1-.385-.469M13 7.48V9.5h-2V6.831c.461.316 1.108.577 2 .65m.5 3.02V13h-3v-2.5zM14 14v4a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-4z"
}), 'Lipstick');
